<template>
    <div v-if="items.length">

        <template v-for="item in items">
            <!-- list_item -->
            <div class="row list_item underlined_item" :data-id="item.id">
                <div class="col-12 col-lg-8 mt_xxs">

                    <div class="media li_group">
                        <div class="li_p">
                            <div v-if="item.is_new" class="item_icon item_icon_left">
                                <img src="/i/new.svg" alt="Новинка" width="24" height="24">
                            </div>
                            
                            <div v-if="item.is_bestseller" class="item_icon item_icon_left">
                                <img src="/i/hit.svg" alt="Хит продаж" width="24" height="24">
                            </div>
                            
                            <div v-if="item.is_sale" class="item_icon item_icon_left">
                                <img src="/i/sale.svg" alt="Распродажа" width="24" height="24">
                            </div>

                            <a :href="'/catalog/item/' + item.slug">
                                <div v-if="item.images && item.images.length" class="item_picture">
                                    <ins v-if="item.images.length > 1" :style="'background-image: url()' + item.images[1].thumb_path + ')'">
                                        <div :style="'background-image: url(' + item.images[0].thumb_path + ')'"></div>
                                    </ins>
                                    <div v-else :style="'background-image: url(' + item.images[0].thumb_path + ')'"></div>
                                </div>
                                <div v-else class="item_picture item_picture_no-image">
                                    <div class="no-image"></div>
                                </div>
                            </a>
                        </div>

                        <div class="media-body">
                            <div class="li_title subtitle">
                                <a :href="'/catalog/item/' + item.slug">{{ item.full_title }}</a>
                            </div>

                            <div class="li_info item_info item_info_horizontal">
                                <p v-if="item.sku"><span>Артикул</span> {{ item.sku }}</p>
                                <p v-if="item.attr_color"><span>Цвет</span> {{ item.attr_color }}</p>
                                <p v-if="item.attr_size"><span>Размер</span> {{ item.attr_size }}</p>
                                <p v-if="item.attr_material"><span>Материал</span> {{ item.attr_material }}</p>
                                <p v-if="item.attr_type"><span>Тип</span> {{ item.attr_type }}</p>
                                <p v-if="item.country"><span>Производитель</span> {{ item.country }}</p>
                                <p v-if="item.attr_other"><span>Прочее</span> {{ item.attr_other }}</p>
                            </div>
                            <div class="li_small small_info">
                                В упаковке по <span class="accent">{{ item.qty_per_pack }} {{ item.unit }}</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-12 col-lg-4 mt_xxs">
                    <div class="li_price">
                        <span v-if="item.old_price" class="other_lg"><s>{{ item.old_price }} р.</s></span>
                        <span class="price_lg">{{ item.price }} р.</span>
                    </div>

                    <div class="li_action">
                        <span v-if="isAuth">
                            <favourites-add-button :id="item.id"></favourites-add-button>
                        </span>

                        <span>
                            <cart-add-button v-if="item.status == 1 || item.status == 3" 
                                :id="item.id" 
                                :qty_per_pack="item.qty_per_pack"
                                :qty_in_stock="item.qty_in_stock"
                                :title="item.title"
                                :sku="item.sku"
                                :price="item.price"
                                category=""
                            ></cart-add-button>
                            <template v-else-if="item.status == 4">
                                <purchase-request-button :id="item.id"></purchase-request-button>

                                <purchase-request-modal v-if="isAuth"
                                    :id="item.id"
                                    :phone="phone"
                                    :email="email"></purchase-request-modal>
                                <purchase-request-modal  v-else
                                    :id="item.id"></purchase-request-modal>
                            </template>
                            <template v-else>
                                <inform-button :id="item.id"></inform-button>
                
                                <inform-modal v-if="isAuth" :id="item.id" :email="email"></inform-modal>
                                <inform-modal v-else :id="item.id"></inform-modal>

                                <inform-unsubscribe-modal :id="item.id"></inform-unsubscribe-modal>
                            </template>
                        </span>
                    </div>

                </div>
            </div>
            <!-- //list_item -->
        </template>

    </div>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {

    components: { Fragment },

    props: ["id", "url", "items"],

    data: function () {
        return {
        };
    },
    methods: {
    },
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },
        
        email() {
            return this.$store.state.email;
        },
        
        phone() {
            return this.$store.state.phone;
        },
    },
};
</script>
